import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './app-button.component.html',
  styleUrls: ['./app-button.component.scss'],
})
export class AppButtonComponent implements OnInit {
  @Input() type: string = 'button';
  @Input() block: boolean = false;
  @Input() color: string = 'primary';
  @Input() text: string = '';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Output() onClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    this.disabled = this.disabled || this.loading;
  }

  click() {
    this.onClick.emit();
  }
}
